import { defineMessages } from "react-intl";

export default defineMessages({
  kortinOtsikko: {
    id: "kaikkiJarjestajat.kortinOtsikko",
    defaultMessage: "Kaikki koulutuksen järjestäjät"
  },
  paasivunOtsikko: {
    id: "kaikkiJarjestajat.paasivunOtsikko",
    defaultMessage: "Kaikki koulutuksen järjestäjät"
  },
  lyhytKuvaus: {
    id: "kaikkiJarjestajat.lyhytKuvaus",
    defaultMessage:
      "Tästä pääset tarkastelemaan kaikkien koulutusmuotojen koulutustoimijoita ja niiden järjestämis- ja ylläpitämislupia."
  },
  sivunKuvaus: {
    id: "kaikkiJarjestajat.lyhytKuvaus",
    defaultMessage:
      "Tällä sivulla voit tarkastella kaikkien koulutusmuotojen koulutustoimijoita ja niiden järjestämis- ja ylläpitämislupia."
  },
  maara: {
    id: "kaikkiJarjestajat.maara",
    defaultMessage: "Koulutuksen järjestäjien määrä {kpl} kpl."
  }
});
